var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClock = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00048 0C3.58202 0 0 3.58111 0 8.00011C0 12.4182 3.58205 16.0002 8.00048 16.0002C12.4185 16.0002 16 12.4182 16 8.00011C16 3.58111 12.4185 0 8.00048 0ZM8.00048 14.35C4.58351 14.35 1.5 11.4162 1.5 8.00011C1.5 4.5831 4.58351 1.5 8.00048 1.5C11.417 1.5 14.4 4.5831 14.4 8.00011C14.4 11.4162 11.417 14.35 8.00048 14.35Z",
    fill: "#FA6400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50049 3.63621H7.09424V8.90678L11.0005 10.9995L12.0005 9.49949L8.50049 7.69972V3.63621Z",
    fill: "#FA6400"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Clock.518708bc.svg";
export { ForwardRef as ReactComponent };